import * as CS from './style';
import * as T from '../Typography';
import colors from '../../theme/colors';
import asterik from '../../components/assets/asterik.svg';
import infoIcon from '../../components/assets/info.svg';
import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { ClickAwayListener } from '@mui/material';

const InputWrapper = (props) => {
  const {
    label,
    error,
    helper,
    w,
    disabled,
    m,
    optional,
    children,
    required,
    info
  } = props;
  const [openTooltip, setOpenTooltip] = useState(false);

  return (
    <CS.Field w={w} disabled={disabled} {...m}>
      {label && (
        <CS.Label htmlFor={label}>
          <T.H16px color={colors.neutral.shades.shade700} weight="bold">
            {label}
          </T.H16px>
          {required && (
            <div style={{ marginBottom: 4, marginLeft: 10 }}>
              <img src={asterik} alt="required" />
            </div>
          )}
          {optional && <CS.OptionalTag ml="1">(optional)</CS.OptionalTag>}
          {info && (
            <ClickAwayListener onClickAway={() => setOpenTooltip(false)}>
              <Tooltip
                PopperProps={{
                  disablePortal: true
                }}
                onClose={() => setOpenTooltip(false)}
                open={openTooltip}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={info}
              >
                <div
                  style={{ marginBottom: 0, marginLeft: 10, cursor: 'pointer' }}
                  onClick={() => {
                    setOpenTooltip(true);
                  }}
                >
                  <img src={infoIcon} alt="info" />
                </div>
              </Tooltip>
            </ClickAwayListener>
          )}
        </CS.Label>
      )}
      {children}
      {info && (
        <CS.HelperWrapper>
          <T.TextSmallRegular
            size="small"
            fontStyle="italic"
            color={colors.neutral.shades.shade500}
            weight="light"
            ml={2}
            mt={2}
          >
            {helper}
          </T.TextSmallRegular>
        </CS.HelperWrapper>
      )}
      {error && (
        <T.TextSmallRegular
          color={colors.red.shades.shade600}
          m="0"
          ml="3"
          mt="2"
        >
          {error}
        </T.TextSmallRegular>
      )}
    </CS.Field>
  );
};

export default InputWrapper;
